import { Component } from '@angular/core';

@Component({
  selector: 'app-split-content',
  imports: [],
  templateUrl: './split-content.component.html',
  styleUrl: './split-content.component.css'
})
export class SplitContentComponent {

}
